var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-checkbox-group',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.genders),callback:function ($$v) {_vm.genders=$$v},expression:"genders"}},_vm._l((_vm.sexList),function(gender){return _c('el-checkbox-button',{key:gender.key,attrs:{"label":gender.key}},[_vm._v(_vm._s(gender.name))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }